module.exports = __webpack_public_path__ + "media/images/capza-6b327aef.png";